import { render } from "./MainView.vue?vue&type=template&id=2afd8eb0&scoped=true"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"

import "@/assets/css/MainView.css?vue&type=style&index=0&id=2afd8eb0&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afd8eb0"]])

export default __exports__